import Grid from '@mui/material/Grid2'
import Divider from '@mui/material/Divider'
import { styled } from '@mui/material/styles'
import Container from '@mui/material/Container'
import { Stack, useMediaQuery, useTheme } from '@mui/material'

import CopyrightTextWrapper from 'wrappers/CopyrightTextWrapper'
import PoweredByWrapper from 'wrappers/poweredBy/PoweredByWrapper'
import FooterLinks from '../../components/shared/footer/FooterLinks'

const FooterRoot = styled('footer')(({ theme }) => ({
  position: 'relative',
  backgroundColor: theme.vars.palette.background.default
}))

export function Footer({ sx, ...other }) {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <FooterRoot sx={sx} {...other}>
      <Divider />
      <Container
        sx={{
          pt: 2,
          pb: 2
        }}
      >
        <Grid
          container
          sx={{
            alignItems: 'center',
            justifyContent: { xs: 'center', sm: 'space-between' }
          }}
        >
          <Grid size={{ xs: 12, sm: 7 }}>
            <Stack
              spacing={1}
              divider={!isMobile ? <>|</> : null}
              direction={{ xs: 'column', sm: 'row' }}
              sx={{ alignItems: 'center' }}
            >
              <CopyrightTextWrapper />
              <FooterLinks />
            </Stack>
          </Grid>

          <Grid size={{ xs: 12, sm: 4 }}>
            <PoweredByWrapper />
          </Grid>
        </Grid>
      </Container>
    </FooterRoot>
  )
}
